import React, { useCallback } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import Dialog from '../../../base/ui/components/web/Dialog';
import { getParticipantDisplayName, isLocalParticipantModerator } from '../../../base/participants';
import { hideDialog } from '../../../base/dialog/actions';
import { sendCommand } from '../../../mod-command/slice';
import { COMMANDS } from '../../../mod-command/constants';
import { getModCommand } from '../../../mod-command/functions';
import { Trans, useTranslation } from 'react-i18next';
/**
 * Dialog to confirm a remote participant kick action.
 */
const ConfirmPinAllDialog = (props) => {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isPinnedAll = useSelector((state) => !!getModCommand(state, COMMANDS.PIN_PARTICIPANT.COMMAND));
    const valueCommand = useSelector((state) => getModCommand(state, COMMANDS.PIN_PARTICIPANT.COMMAND));
    const displayName = getParticipantDisplayName(APP.store.getState(), props.participantID);
    const isOwner = isLocalParticipantModerator(APP.store.getState());
    const handlePinnedParticipant = useCallback(() => {
        if (isOwner) {
            if (isPinnedAll && (valueCommand?.value === props.participantID)) {
                dispatch(sendCommand(COMMANDS.UN_PIN_PARTICIPANT.COMMAND, props.participantID, true));
            }
            else {
                dispatch(sendCommand(COMMANDS.PIN_PARTICIPANT.COMMAND, props.participantID, true));
            }
        }
        dispatch(hideDialog(ConfirmPinAllDialog));
    }, [dispatch, props.participantID, isPinnedAll]);
    // const _onSubmit = () => {
    //     if (isOwner) {
    //         handlePinnedParticipant
    //     }
    //     props.dispatch(hideDialog(ConfirmPinAllDialog))
    // }
    return (React.createElement(Dialog, { ok: { translationKey: isPinnedAll && (valueCommand?.value === props.participantID) ? 'dialog.unPinScreenToAll' : 'dialog.pinScreenToAll' }, onSubmit: handlePinnedParticipant, title: isPinnedAll && (valueCommand?.value === props.participantID) ? t('dialog.titleUnpinScreenToAll') : t('dialog.titlePinScreenToAll') }, (isPinnedAll && (valueCommand?.value === props.participantID)) ?
        React.createElement(Trans, { i18nKey: "dialog.descUnPinScreenToAll", values: { screenName: displayName } }) :
        React.createElement(Trans, { i18nKey: "dialog.descPinScreenToAll", values: { screenName: displayName } })));
};
export default translate(connect()(ConfirmPinAllDialog));
